import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

@Injectable()
/* todo: rename gasService -> configService */
export class GasService {

  public withdraw: number = 0;
  public deposit: number = 0;
  public updateState: number = 0;
  private _lastUpdate: Date = null;
  private _updated: boolean = false;
  private _updating: boolean = false;

  public withdrawLimit = 500;

  constructor(private http: Http) {
    this.getPrices();
  }

  public getPrices(): void {
    if (this._updating) {
      return;
    }
    this._updating = true;
    this.http.get('/api/config/gas').subscribe((data: any) => {
      const value = data.json();
      this.withdraw = Number(value.withdraw.toFixed(2));
      this.deposit = Number(value.deposit.toFixed(2));
      this.updateState = Number(value.updateState.toFixed(2));
      this._updated = true;
      this._updating = true;
      this._lastUpdate = new Date();
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/gas.service.ts